import OutingDTO from '@dto/outing_dto'
import axios from 'axios'
import { stringifyError } from '@utils/axios'

const POS_MAPS_BOAT_URL = 'rpc/pos_maps_boats'

export default class OutingRepository {
  static get(boatUuid: string): Promise<OutingDTO> {
    return new Promise<OutingDTO>((resolve, reject) => {
      axios
        .post<OutingDTO[]>(POS_MAPS_BOAT_URL, { b_uuid: boatUuid })
        .then((request) => {
          const httpIsError = request.status >= 400
          if (httpIsError) {
            return reject(`Impossible d'accèder à l'API.
${request.status} : ${request.statusText}`)
          }

          const hasABoat = request.data && request.data.length > 0
          if (hasABoat) {
            resolve(request.data[0])
          } else {
            reject("Aucune position pour ce bateau dans l'intervalle de temps.")
          }
        })
        .catch((error) => reject(stringifyError(error)))
    })
  }
}
